import React from "react";
import { useDrag } from "react-dnd";

import { InputCursorText, CardText, UiRadiosGrid, CheckSquare, FileEarmarkArrowUp, MenuButtonWideFill, TypeH1, Hr, Fonts, TagFill } from 'react-bootstrap-icons';

const DutieField = ({ fieldInput }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "FORM_FIELD",
    item: { fieldInput },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div ref={drag} style={{ display: "flex", alignItems: "center", opacity: isDragging ? 0.5 : 1 }}>
      <img src={fieldInput.ProfileImage} style={{width: "25px", borderRadius: "500px"}}/>
      <p style={{marginBottom: "0px", marginLeft: "10px"}}>{fieldInput.Name} {fieldInput.Surname}</p>
    </div>
  );
};

export default DutieField;
